import { BorderGridContainer, Button, GridBox, H2, SpacerWrapper, TypeWrapper } from '@ahmdigital/ui';
import { isEmpty } from 'lodash/fp';
import React from 'react';

import FeaturesOrBenefitsSection from './features-or-benefits-section';
import pageStyles from '../../styles.module.sass';
import type { FeaturesAndBenefitsContent } from '../../types';

function FeaturesAndBenefits({ whatsIncluded, addOns = [], urlObject }: FeaturesAndBenefitsContent): JSX.Element {
  return (
    <BorderGridContainer>
      <GridBox padding="1rem">
        <div className={pageStyles.horizontalSpacingWrapper}>
          <SpacerWrapper variant={['paddingTopSpacer3', 'paddingBottomSpacer9']}>
            <TypeWrapper variant="center">
              <H2 variant="marginBottomSpacer4">Features and Benefits</H2>
            </TypeWrapper>
            {!isEmpty(whatsIncluded) ? <FeaturesOrBenefitsSection items={whatsIncluded} type="inclusions" /> : null}
            {!isEmpty(addOns) ? <FeaturesOrBenefitsSection items={addOns} type="addons" /> : null}
          </SpacerWrapper>
          <SpacerWrapper variant={['paddingTopSpacer6', 'paddingBottomSpacer6']}>
            <TypeWrapper variant="center">
              {urlObject?.url && urlObject?.name && <Button to={urlObject.url}>{urlObject.name}</Button>}
            </TypeWrapper>
          </SpacerWrapper>
        </div>
      </GridBox>
    </BorderGridContainer>
  );
}

export default FeaturesAndBenefits;
